import React, { useState, useRef, useEffect } from "react";
import classes from "./TagSelectInput.module.scss";
import {
  CUSTOM_BIRTH_DATE,
  CUSTOM_INVITE_CODE,
  CUSTOM_OCCUPATION,
} from "../../../../constants/users_login";
import useFetch from "../../../../hooks/useFetch";
import { API_URL_STATIC_OPTIONS } from "../../../../constants/api";
import Checkbox from "../../../UI/Checkbox/Checkbox";

const TagSelectInput = ({
  className = "",
  label = null,
  name = "",
  showTextError = "",
  errorButton = "",
  textError = "",
  signUpForm = "",
  setSignUpForm = "",
}) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [showOptions, setShowOptions] = useState(false);
  const [occupationChecked, setOccupationChecked] = useState(false);
  const listRef = useRef(null);
  const inputRef = useRef(null);

  const [options, options_isLoading, , fetchOptions] = useFetch({
    autoInit: false,
    noAuth: true,
  });

  useEffect(() => {
    fetchOptions({
      url: API_URL_STATIC_OPTIONS,
    });
  }, []);

  const handleInputChange = (e) => {
    setSearchTerm(e.target.value.toLowerCase());

    setSignUpForm({
      ...signUpForm,
      [CUSTOM_OCCUPATION]: e.target.value.toLowerCase(),
    });

    setShowOptions(true);
  };

  const handleOptionClick = (item) => {
    setSearchTerm(item);
    setSignUpForm({
      ...signUpForm,
      [CUSTOM_OCCUPATION]: item,
    });
    setShowOptions(false);
  };

  const filteredItems = options?.professions.filter((item) =>
    item.toLowerCase().includes(searchTerm)
  );

  const handleDocumentClick = (e) => {
    if (listRef.current && !listRef.current.contains(e.target) && showOptions) {
      setShowOptions(false);
    }
  };

  const handleInputClick = () => {
    setShowOptions(true);
  };

  const handleCheckboxChange = () => {
    setOccupationChecked(!occupationChecked);
    occupationChecked &&
      setSignUpForm({
        ...signUpForm,
        [CUSTOM_OCCUPATION]: "Não possuo ocupação".toLowerCase(),
      });
  };

  useEffect(() => {
    if (occupationChecked) {
      setSearchTerm("Não possuo ocupação");
      setSignUpForm({
        ...signUpForm,
        [CUSTOM_OCCUPATION]: "Não possuo ocupação",
      });
    } else {
      setSearchTerm("");
      setSignUpForm({
        ...signUpForm,
        [CUSTOM_OCCUPATION]: "",
      });
    }
  }, [occupationChecked]);

/*   useEffect(() => {
    document.body.addEventListener("click", handleDocumentClick);

    return () => {
      document.body.removeEventListener("click", handleDocumentClick);
    };
  }, []); */
  return (
    <div className={className}>
      {label && (
        <label className={classes.Label} htmlFor={"id_" + [name]}>
          {label}
          <b> *</b>
        </label>
      )}
      <input
        className={
          showTextError && errorButton
            ? classes.TagInputError
            : classes.TagInput
        }
        type="text"
        placeholder="Ocupação"
        value={searchTerm}
        onChange={handleInputChange}
        onClick={handleInputClick}
        ref={inputRef}
      />
      
      {showOptions && filteredItems.length > 0 && (
        <div className="search-list" ref={listRef}>
          <ul className={classes.TagInputOptions}>
            {filteredItems.map((item, index) => (
              <li key={index} onClick={() => handleOptionClick(item)}>
                {item}
              </li>
            ))}
          </ul>
        </div>
      )}
      <div className={classes.checkbox}>
        <Checkbox
          value={occupationChecked}
          onClick={() => handleCheckboxChange()}
        >
          <span onClick={() => handleCheckboxChange()}>
            Não possuo ocupação
          </span>
        </Checkbox>
      {showTextError && errorButton && (
        <div className={classes.errorDiv}>{textError}</div>
      )}
      </div>
    </div>
  );
};

export default TagSelectInput;
